import { Injectable } from '@angular/core';
import { EQueryFilterDefinitions } from './e-query-filter-definitions';
import { FilterFieldValue } from '../covance-filter';

@Injectable()
export class ExternalUserEQueriesFilterDefinitions {
    constructor(private readonly eQueryFilterDefinitions: EQueryFilterDefinitions) {
    }

    public getAwaitingFilterDefinitions(): FilterFieldValue[] {
        return [
            this.eQueryFilterDefinitions.accessionNo(),
            this.eQueryFilterDefinitions.visitCollectionDate(),
            this.eQueryFilterDefinitions.status(),
            this.eQueryFilterDefinitions.visitName(),
            this.eQueryFilterDefinitions.pVc(),
            this.eQueryFilterDefinitions.subject(),
            this.eQueryFilterDefinitions.eQueryId(),
            this.eQueryFilterDefinitions.age()];
    }

    public getSubmittedFilterDefinitions(): FilterFieldValue[] {
        return [
            this.eQueryFilterDefinitions.accessionNo(),
            this.eQueryFilterDefinitions.visitCollectionDate(),
            this.eQueryFilterDefinitions.status(),
            this.eQueryFilterDefinitions.visitName(),
            this.eQueryFilterDefinitions.pVc(),
            this.eQueryFilterDefinitions.subject(),
            this.eQueryFilterDefinitions.eQueryId()];
    }
}
